// extracted by mini-css-extract-plugin
export default {"kc3TotalTable":"ActKC3Totals_kc3TotalTable__1h0G1"};